import { ShieldCheck, Award, Hammer, BadgePoundSterling } from "lucide-react";
import { ACCREDITATIONS, PILLARS } from "../../lib/site";
import { Reveal } from "../site/Reveal";

const PILLAR_ICONS = [ShieldCheck, Award, Hammer, BadgePoundSterling];

export const TrustBanner = () => (
  <section className="relative bg-forest-surface py-20 md:py-28 border-y border-white/10 noise-overlay" data-testid="trust-banner">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal className="flex flex-wrap items-center justify-center gap-x-4 gap-y-4 mb-16">
        {ACCREDITATIONS.map((a, i) => (
          <div key={a} className="flex items-center gap-3">
            <span className="inline-flex items-center gap-2 rounded-full border border-brand-orange/40 bg-forest/40 px-5 py-3">
              <ShieldCheck className="h-5 w-5 text-brand-orange" />
              <span className="font-display uppercase tracking-[0.14em] text-sm text-cream">{a}</span>
            </span>
            {i < ACCREDITATIONS.length - 1 && <span className="hidden sm:block text-brand-orange/50 text-xl">/</span>}
          </div>
        ))}
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-xl overflow-hidden">
        {PILLARS.map((p, i) => {
          const Icon = PILLAR_ICONS[i];
          return (
            <Reveal
              key={p.title}
              delay={i * 0.08}
              className="group bg-forest p-8 hover:bg-forest-deep transition-colors duration-400"
              data-testid={`pillar-${i}`}
            >
              <Icon className="h-9 w-9 text-brand-orange mb-6 transition-transform duration-300 group-hover:scale-110" strokeWidth={1.6} />
              <h3 className="font-display uppercase tracking-tight text-2xl text-cream leading-none">{p.title}</h3>
              <p className="mt-3 text-cream/60 text-sm leading-relaxed">{p.desc}</p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
